<template>
  <div class="payment">
    <span class="label">{{ $t('支付方式') }}</span>
    <PayWaysBtn @selectpayment="selectPayment" :noHasPayment="noHasPayment" />
  </div>
</template>

<script>
import PayWaysBtn from './payWaysBtn';
export default {
  name: 'PaymentMethod',
  props: {
    noHasPayment: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PayWaysBtn,
  },
  methods: {
    selectPayment() {
      this.$emit('selectpayment');
    },
  },
};
</script>

<style lang="scss" scoped>
.payment {
  display: flex;
  border-radius: 8px;
  background: #fff;
  padding: 20px 17px;
  box-sizing: border-box;
  .label {
    display: flex;
    font-family: 'Aspira Light';
    font-weight: 200;
    font-size: 16px;
    color: #000;
    flex: 1;
    text-align: left;
    align-items: center;
  }
}
@media screen and (max-width: 768px) {
  .payment {
    padding: rem(40) rem(18);
    .label {
      font-size: rem(36);
    }
  }
}
</style>